import { Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable()
export class ApScrollService {
    private readonly document = inject<Document>(DOCUMENT);

    /**
     * Scroll to any DOM element with a DOM selector
     *
     * @param selector [DOM selector]{@link https://developer.mozilla.org/en-US/docs/Web/API/Document_object_model/Locating_DOM_elements_using_selectors}
     */
    public scrollTo(selector: string): void {
        const elem = this.document.querySelector(selector);

        if (elem) {
            elem.scrollIntoView({ behavior: 'smooth' });
        }
    }

    /**
     * Scroll to the top of the page
     */
    public scrollToTop(): void {
        this.document.body.scrollTop = 0;
        this.document.documentElement.scrollTop = 0;
    }

    /**
     * Scroll to (whichever comes first) `ap-notification` with status error or angular field error
     */
    public scrollToInputError(): void {
        const errorElements = Array.from(
            this.document.querySelectorAll(
                'ap-notification[status="error"], ap-notification[ng-reflect-status="error"], label.ng-invalid, input.ng-invalid, .ng-invalid'
            )
        );
        const sortedElements = ['ap-notification', 'label', 'input'];

        errorElements.sort((one: Element, two: Element) => {
            const t1 = sortedElements.indexOf(one.tagName.toLowerCase());
            const t2 = sortedElements.indexOf(two.tagName.toLowerCase());

            if (t1 === -1 || t2 === -1) {
                return t1 > t2 ? -1 : 1;
            }
            return t1 - t2;
        });

        errorElements[0]?.scrollIntoView({ behavior: 'smooth' });
    }
}
